import { InstanceScreen } from 'component/navigation/instance';

export default function SpaceConversationHelperAdminScreen() {
    return <InstanceScreen screenKey='conversationhelperadmin' />;
}
